// "Contact support" from an error: the support composer when it is on screen (pre-filled with the
// reference), else LiveChat (the reference set as a chat variable staff see), else an email to
// support@lunch.team with the reference in the subject.
import { isComposerShown, openSupportComposer } from './supportEntry';

export const SUPPORT_EMAIL = 'support@lunch.team';

/** The message the customer starts from: what failed and the reference. No personal data. */
export function supportMessageFor(error) {
  const lines = [];
  if (error && error.title) lines.push(`${error.title}.`);
  if (error && (error.fullReference || error.reference)) {
    lines.push(`Reference: ${error.fullReference || error.reference}`);
  }
  return lines.join('\n');
}

export function supportMailto(error) {
  const reference = error && (error.fullReference || error.reference);
  const subject = reference ? `Help with ${reference}` : 'Help with Lunch.Team';
  const body = supportMessageFor(error);
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}${
    body ? `&body=${encodeURIComponent(`${body}\n\n`)}` : ''
  }`;
}

function liveChatOpen(error) {
  if (typeof document !== 'undefined') {
    const root = document.documentElement;
    // Hidden on phones and while the composer has taken over.
    if (
      root.classList.contains('lunchteam-livechat-off') ||
      root.classList.contains('lunchteam-mobile-surface')
    ) {
      return false;
    }
  }
  const reference = (error && (error.fullReference || error.reference)) || '';
  try {
    if (window.LiveChatWidget && typeof window.LiveChatWidget.call === 'function') {
      if (reference) {
        window.LiveChatWidget.call('set_session_variables', {
          support_reference: reference,
        });
      }
      window.LiveChatWidget.call('maximize');
      return true;
    }
    if (window.LC_API && typeof window.LC_API.open_chat_window === 'function') {
      if (reference && typeof window.LC_API.set_custom_variables === 'function') {
        window.LC_API.set_custom_variables([
          { name: 'support_reference', value: reference },
        ]);
      }
      window.LC_API.open_chat_window();
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
}

/** Opens the best support route for this error. Returns 'composer' | 'livechat' | 'email'. */
export function contactSupport(error) {
  if (isComposerShown()) {
    openSupportComposer({ text: supportMessageFor(error) });
    return 'composer';
  }
  if (liveChatOpen(error)) {
    return 'livechat';
  }
  window.location.href = supportMailto(error);
  return 'email';
}



// WEBPACK FOOTER //
// ./src/support/contactSupport.js